import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { QuotesDataSource } from '../../datasources/quotes-data-source';
import { ListComponent } from '../list.component';


@Component({
  selector: 'app-list-desktop',
  templateUrl: './list-desktop.component.html',
  styleUrls: ['./list-desktop.component.scss']
})
export class ListDesktopComponent extends ListComponent implements OnInit, AfterViewInit, OnDestroy {

  dataSource: QuotesDataSource;
  displayedColumns: string[] =
    ['projectName', 'projectNbr', 'customerName', 'jobType', 'bidAmount', 'quoteDate', 'projectStatus', 'acknowledgementStatus', 'salesperson', 'action'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit(): void {
    this.dataSource = new QuotesDataSource(this.quoteService);
    this.loadQuotes();

    super.init();
  }

  ngAfterViewInit() {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadQuotes())
      )
      .subscribe();

    this.paginator.page
      .pipe(
        tap(() => this.loadQuotes())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sort.sortChange.unsubscribe();
    this.paginator.page.unsubscribe();
  }

  loadQuotes() {
    this.dataSource.loadQuotes(this.filter, this.sort.active,
      this.sort.direction, this.paginator.pageIndex);
  }

  refreshSummary() {
    this.loadSummary();
    this.loadQuotes();
  }
}
